import {
  Amount, GenericBindResponse, GenericQuoteSuccessResponse, TrackingCode,
} from '@sky-distribution/adapter-core-pc-rest-interfaces';
import { BuyResponse } from '@sky-distribution/backend-gp-onboarding-interfaces';
import { Consent } from '@sky-distribution/digital-gp-submission';
import {
  CreateResponse,
  DetailsResponse,
  policyService,
  QuoteResponse,
  RateArgs,
  RateResponse,
  SubmissionArgs,
  SubmissionIds,
  UpdateResponse,
} from '@sky-distribution/gp-onboarding-policy-service';
import {
  productConfigurationService,
  ProductMetaDataResponse,
} from '@sky-distribution/gp-onboarding-product-configuration-service';

export async function create(
  submission: SubmissionArgs,
  productId: string,
  consentStatus: Record<string, boolean>,
  consentDictionary: Consent[],
  trackingCodes?: TrackingCode[],
  tenant?: string,
  context?: string,
): Promise<CreateResponse> {
  return policyService.create(submission, productId, consentStatus, consentDictionary, trackingCodes, tenant, context);
}

export async function quote(
  submission: SubmissionArgs,
  ids: SubmissionIds,
  productId: string,
  consentStatus: Record<string, boolean>,
  consentDictionary: Consent[],
  trackingCodes?: TrackingCode[],
  context?: string,
  tenant?: string,
): Promise<QuoteResponse> {
  return policyService.quote(
    submission,
    ids,
    productId,
    consentStatus,
    consentDictionary,
    trackingCodes,
    context,
    tenant,
  );
}

export async function quoteRenewal(
  ids: SubmissionIds,
  productId: string,
  consentStatus: Record<string, boolean>,
  consentDictionary: Consent[],
): Promise<GenericQuoteSuccessResponse> {
  return policyService.quoteRenewal(ids, productId, consentStatus, consentDictionary);
}

export async function update(
  submission: SubmissionArgs,
  ids: SubmissionIds,
  productId: string,
  consentStatus: Record<string, boolean>,
  consentDictionary: Consent[],
  trackingCodes?: TrackingCode[],
  context?: string,
): Promise<UpdateResponse> {
  return policyService.update(submission, ids, productId, consentStatus, consentDictionary, trackingCodes, context);
}

export async function buy(
  submission: SubmissionArgs,
  ids: SubmissionIds,
  productId: string,
  totalPrice?: Amount,
  returnUrl?: string,
  brand?: string,
): Promise<BuyResponse> {
  return policyService.buy(submission, ids, productId, totalPrice, returnUrl, brand);
}

export async function bindWithOTP(
  submission: SubmissionArgs,
  ids: SubmissionIds,
  productId: string,
  otpCode?: string,
  totalPrice?: Amount,
): Promise<GenericBindResponse> {
  return policyService.bindWithOTP(submission, ids, productId, otpCode, totalPrice);
}

export async function rate(rateData: RateArgs, productId: string): Promise<RateResponse> {
  return policyService.rate(rateData, productId);
}

export async function retrieveSales(ids: SubmissionIds, productId: string): Promise<DetailsResponse> {
  return policyService.retrieveService(ids, productId);
}

export async function getProductMetaData(rateData: RateArgs): Promise<ProductMetaDataResponse> {
  const { partner, businessProductCode } = rateData;

  return productConfigurationService.getProductMetaData(partner, businessProductCode);
}
